import { render, staticRenderFns } from "./LegalProjectAnnounce.vue?vue&type=template&id=cf5dda22&scoped=true&"
import script from "./LegalProjectAnnounce.vue?vue&type=script&lang=js&"
export * from "./LegalProjectAnnounce.vue?vue&type=script&lang=js&"
import style0 from "./LegalProjectAnnounce.vue?vue&type=style&index=0&id=cf5dda22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5dda22",
  null
  
)

export default component.exports